import { render, staticRenderFns } from "./car-keyboard.vue?vue&type=template&id=6c16db37&scoped=true"
import script from "./car-keyboard.vue?vue&type=script&lang=js"
export * from "./car-keyboard.vue?vue&type=script&lang=js"
import style0 from "./car-keyboard.vue?vue&type=style&index=0&id=6c16db37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c16db37",
  null
  
)

export default component.exports